export default __webpack_public_path__ + "static/media/thumbnil1.23f74f51.png";